import React from 'react';

const ScrollTop = () => {
    return (
        <>
                <a href="#" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>
        </>
    );
}

export default ScrollTop;